import React from 'react'
import { DialogTitle, DialogContent, DialogActions, DialogContentText, Collapse } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ResponsiveDialog from 'components/ResponsiveDialog'
import Button from 'components/Button'
import InfoMessage from 'components/InfoMessage'
import { PageLoadingIndicator } from 'components/Layouts/V3'
import Condition from 'components/Condition'

export interface ISocialLinksUpdateResumeDialogProps {
  open: boolean
  resumeLoading: boolean
  resumeError?: string
  onClose: () => void
  onAttach: () => void
  onImport: () => void
}

function SocialLinksUpdateResumeDialog(props: ISocialLinksUpdateResumeDialogProps) {
  const { open, resumeLoading, resumeError, onAttach, onImport, onClose } = props
  const theme = useTheme()

  return (
    <ResponsiveDialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>
        Import data from Resume?
      </DialogTitle>

      <DialogContent>
        <Collapse in={resumeLoading}>
          <PageLoadingIndicator />
        </Collapse>

        <Collapse in={!resumeLoading}>
          <DialogContentText>
            Do you want to update your profile automatically from the data in your resume, or just attach your resume to your profile as a link?
            <br />
            <br />
            Note: choosing to update your profile from your resume may take a few minutes.
          </DialogContentText>

          <Condition condition={Boolean(resumeError)}>
            <InfoMessage style={{ marginTop: theme.spacing(4) }}>
              {resumeError}
            </InfoMessage>
          </Condition>
        </Collapse>
      </DialogContent>

      <DialogActions>
        <Button disabled={resumeLoading} onClick={onClose}>
          Cancel
        </Button>

        <Button disabled={resumeLoading} onClick={onAttach} color="secondary">
          Just attach
        </Button>

        <Button disabled={resumeLoading} onClick={onImport} color="primary">
          Update Profile & Attach
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}

export default React.memo(SocialLinksUpdateResumeDialog)
